import { Component, OnInit, inject } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'

import { HuntPackageRecord, Profile } from '@cyborg-monorepo/hunter/common'
import { BaseDialogComponent } from '@hyperkit'

import { SupportService } from '../../../services/support.service'
import { UserService } from '../../../services/user.service'

@Component({
  standalone: false,
  selector: 'cyborg-modal-unlock',
  templateUrl: './unlock.component.html',
  styleUrls: ['./unlock.component.scss'],
})
export class UnlockModalComponent
  extends BaseDialogComponent<{ huntPackage: Partial<HuntPackageRecord> }, void>
  implements OnInit
{
  private userService = inject(UserService)
  supportService = inject(SupportService)

  public unlockForm: FormGroup
  public email: string
  public submitted = false
  public error: string

  public ngOnInit(): void {
    this.unlockForm = new FormGroup({
      message: new FormControl('', [Validators.required]),
    })

    this.userService.loadProfile().subscribe((profile: Profile) => {
      this.email = profile.email
    })
  }

  public onClose(): void {
    this.dialogRef.close()
  }

  public onUnlock(): void {
    this.supportService
      .sendUnlockEmail({
        message: this.unlockForm.value.message,
        requestedContent: this.data.huntPackage.title,
        contentUrl:
          window.location.origin +
          '/research/hunt-package/' +
          this.data.huntPackage.UUID,
      })
      .subscribe(
        () => {
          this.submitted = true
          this.unlockForm.patchValue({
            message: '',
          })
        },
        (error) => {
          this.error = error.message
        },
      )
  }

  protected initializeOptions(): void {
    this.options = { headerText: 'Unlock Content' }
  }
}
